const ORGAO_KEYS = [
  'orgao',
  'orgaoNome',
  'nomeOrgao',
  'nome_orgao',
  'orgaoId',
  'idOrgao',
  'id_orgao',
  'codigoOrgao',
  'codigo_orgao',
  'cdOrgao',
  'cd_orgao',
  'idOrgaoFp',
  'id_orgao_fp',
  'tx_nm_orgao',
  'lotacao',
];

function findServidorOrgaoValue(
  data: unknown,
  visited = new WeakSet<object>(),
): unknown {
  if (!data || typeof data !== 'object') {
    return '';
  }

  if (visited.has(data)) {
    return '';
  }

  visited.add(data);

  const record = data as Record<string, unknown>;

  for (const key of ORGAO_KEYS) {
    if (record[key] !== undefined && record[key] !== null) {
      return record[key];
    }
  }

  for (const value of Object.values(record)) {
    const orgaoValue = findServidorOrgaoValue(value, visited);

    if (orgaoValue) {
      return orgaoValue;
    }
  }

  return '';
}

export function getServidorOrgaoNome(data: unknown): string {
  const orgaoValue = findServidorOrgaoValue(data);

  if (typeof orgaoValue !== 'string') {
    return '';
  }

  const trimmedValue = orgaoValue.trim();

  if (/^\d+$/.test(trimmedValue)) {
    return '';
  }

  return trimmedValue;
}

export function getServidorOrgaoId(data: unknown): string {
  const value = findServidorOrgaoValue(data);

  if (value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'number' && Number.isFinite(value)) {
    return String(value);
  }

  if (typeof value === 'string') {
    const trimmedValue = value.trim();

    if (/^\d+$/.test(trimmedValue)) {
      return trimmedValue;
    }
  }

  if (typeof value === 'object') {
    return getServidorOrgaoId(value);
  }

  return '';
}
